import 'Styles/forumview.scss';

import React from 'react';
import { connect } from 'react-redux';

import announcementsViewSelector from 'Selectors/announcementsViewSelector';
import { openAnnouncements, closeAnnouncements } from 'Actions/UiActions';
import { trackGAEvent } from 'Actions/adsActions';

import AnnouncementsList from 'Components/threads/AnnouncementThreadListComponent';
import StickiesList from 'Components/threads/StickyThreadListComponent';
import SvgIcon from 'Components/svg/SvgIcon';

class AnnouncementsViewComponent extends React.Component {
	constructor( props ) {
		super( props );
		this.state = {
			sticky: false,
			announcement: false
		};

		this.annContainer = {};
		this.stickiesAlone = false;
	}

	componentWillMount() {
		// We need to check if we only have stickies in the page
		if(
			( this.props.forumview.entities.forums === undefined || Object.keys( this.props.forumview.entities.forums ).length <= 1 ) &&
			( this.props.forumview.entities.topics === undefined || Object.keys( this.props.forumview.entities.topics ).length === 0 )
		) {
			this.stickiesAlone = true;
		}
	}

	componentDidMount() {
		this.props.dispatch( closeAnnouncements() );
		this.bottomFloatingAd = document.getElementById( 'Fixed_Bottom_Leaderboard_container' );
	}

	componentWillUnmount() {
		this.props.dispatch( closeAnnouncements() );
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.forumview.loaded !== this.props.forumview.loaded
			|| nextProps.forumview.isFetching !== this.props.forumview.isFetching
			|| nextProps.forumview.forumId !== this.props.forumview.forumId
			|| nextProps.announcementsOpen !== this.props.announcementsOpen
		);
	}

	componentWillReceiveProps(nextProps) {
		if( nextProps.forumview.forumId !== this.props.forumview.forumId ) {
			this.props.dispatch( closeAnnouncements() );
		}
	}

	announcementsView = ( e ) => {
		let type = e.currentTarget.dataset.type,
			actionStats = type + 'Topics' ;

		if( this.props.announcementsOpen && this.state[ type ] ) {
			this.setState( { [type]: false } );
			this.props.dispatch( closeAnnouncements() );

			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, `hide${ actionStats }`, 'uiAction', 'tap') );

		} else if( this.annContainer[ type ] ) {
			this._fixHeightByBottomFixAdPosition( type );
			this.setState( { [type]: true } );
			this.props.dispatch( openAnnouncements() );

			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, `show${ actionStats }`, 'uiAction', 'tap') );
		}
	};

	_fixHeightByBottomFixAdPosition( type ) {
		let bottomFloatingAd = this.bottomFloatingAd || document.getElementById( 'Fixed_Bottom_Leaderboard_container' );
		if( bottomFloatingAd ) {
			try {
				this.annContainer[ type ].style.bottom = bottomFloatingAd.getBoundingClientRect().height + 'px';
			} catch( e ) { /* ignore */
			}
		}
	}

	buildPage( type ) {
		const { result } = this.props.forumview;

		let elementsLength = 0,
			elementsList = null,
			iconName = 'error_outline';

		switch( type ) {
			case 'sticky':
				iconName = 'pin';
				elementsLength = result.sticky.length;
				elementsList = <StickiesList key="stickiesList" />;
				break;

			case 'announcement':
				iconName = 'announcement';
				elementsLength = result.announcements.length;
				elementsList = <AnnouncementsList key="announcementsList" />;
				break;
		}

		let areAnnouncementsOpen = this.state[ type ] && elementsLength > 0 && this.props.announcementsOpen ? ' open' : '',
			announcementsIcon = elementsLength > 0 ?
				<div className={ `announcements-icon ${ type }${ this.state[ type ] ? ' open' : '' }` } data-type={ type } onClick={ this.announcementsView }>
					<SvgIcon icon={ this.props.announcementsOpen ? 'clear' : iconName } size="16px" />
				</div> :
				null;

		// if we have no topics and no sub-forums show stickies as regular threads
		return type === 'sticky' && this.stickiesAlone ?
			elementsList :
			(
				<div key={ type }>
					{ announcementsIcon }
					<section className={ `thread pivotal announcements${ areAnnouncementsOpen }` } ref={ ( h ) => this.annContainer[ type ] = h }>
						{ elementsList }
					</section>
				</div>
			);
	}

	buildElements() {
		let elements = [],
			announcements = [],
			stickies = null;

		// get announcements if we have any
		announcements.push( this.buildPage( 'announcement' ) );

		// if we have stickies alone not include them in the container
		if( this.stickiesAlone ) {
			stickies = this.buildPage( 'sticky' );
		} else {
			announcements.push( this.buildPage( 'sticky' ) );
		}

		let floatingEl = announcements.length ? <div key="container">{ announcements }</div> : null;

		elements.push( floatingEl );
		elements.push( stickies );

		return elements;
	}

	render() {
		const { loaded } = this.props.forumview;
		let anyOpen = this.props.announcementsOpen ? ' open' : '';

		if( !loaded ) {
			return null;
		}

		return <section className={ `announcements-container${ anyOpen }` }>{ this.buildElements() }</section>;
	}
}

export default connect( announcementsViewSelector )( AnnouncementsViewComponent );


// WEBPACK FOOTER //
// ./src/components/forums/AnnouncementsViewComponent.js